<template>
  <div class="d-flex gap-3 align-items-center mb-2 reference-table-actions">
    <CButton
      v-if="buttons.includes(CREATE)"
      @click="$emit(CREATE)"
      color="primary"
      style="max-width: 264px"
      class="d-flex gap-3 justify-content-around align-items-center w-100"
    >
      <em class="mz-icon icon-add"/>
      <slot name="new-btn-content">Ajouter une nouvelle {{ tableName }}</slot>
    </CButton>
    <CButton
      v-if="buttons.includes(TEMPLATE)"
      @click="$emit(TEMPLATE)"
      class="w-100"
      style="background-color: #2271AE; color: white; max-width: 289px"
    >
      Télécharger le template des {{ pluralName }}
    </CButton>
    <FileDragdrop @upload="(files) => $emit(UPLOAD, files)" v-if="buttons.includes(UPLOAD)">
      <template slot="upload-button">
        <CButton
          class="w-100"
          type="file"
          style="background-color: #2271AE; color: white"
        >
          Charger le fichier des {{ pluralName }}
        </CButton>
      </template>
    </FileDragdrop>
    <CButton
      v-if="buttons.includes(MANAGE)"
      @click="$emit(MANAGE)"
      color="primary"
      style="max-width: 166px"
      class="ml-auto w-100"
      :disabled="disabledButtons.includes(MANAGE)"
    >
      {{ manageButtonContent }}
    </CButton>
    <CButton
      v-if="buttons.includes(EXPORT)"
      @click="$emit(EXPORT)"
      color="secondary"
      style="max-width: 219px"
      class="d-flex justify-content-around align-items-center gap-3 w-100"
      :class="{'ml-auto': !buttons.includes(MANAGE)}"
    >
      <em class="mz-icon icon-download"/>
      Exporter les {{ pluralName }}
    </CButton>
  </div>
</template>

<script>
export default {
  name: "ReferenceTableActions",
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    disabledButtons: {
      type: Array,
      default: () => []
    },
    manageButtonContent: String,
    tableName: {
      type: String,
      required: true,
    },
    isPlural: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    pluralName() {
      return `${this.tableName}${this.isPlural ? "s" : ""}`;
    },
  },
  data() {
    return {
      CREATE: 'create',
      TEMPLATE: 'template',
      UPLOAD: 'upload',
      MANAGE: 'manage-button',
      EXPORT: 'export',
    }
  },
}
</script>
<style lang="scss">
.reference-table-actions .dragdrop {
  max-width: 248px;
  width: 100%;
}

</style>
